module.exports = __webpack_public_path__ + "static/Anbaugebiet-Rheingau-800x498-732987bdfee7a5dfb3f27be768e3b33f.jpeg";